import React from "react";
import "./Multimedia_Advertising.css";
import Service_outer_card from "../../../Common_Component/Service_outer_card/Service_outer_card";



function Multimedia_Advertising() {

  const data = [
    {
      id:1,
      title: "Digital Screens",
      description: "LED display advertising is a vibrant & versatile way to showcase your brand. Ideal for both indoor & outdoor locations...",
      bgImgSrc: "/Assets/Images/Service/Services/multimediaAdvertisement/bgimg1.png",
      MainImgSrc: "/Assets/Images/Service/Services/multimediaAdvertisement/img1.png",
      baseLink: "/multimedia-services"
    },

    {
      id:2,
      title: "Radio",
      description: "Radio advertising continues to be one of the most reliable ways to connect with audiences.",
      bgImgSrc: "/Assets/Images/Service/Services/multimediaAdvertisement/bgimg2.png",
      MainImgSrc: "/Assets/Images/Service/Services/multimediaAdvertisement/img2.png",
       baseLink: "/multimedia-services"
    },

    {
      id:3,
      title: "T.V. Ads",
      description: "Television advertising is one of the most powerful tools for building brand awareness and credibility.",
      bgImgSrc: "/Assets/Images/Service/Services/multimediaAdvertisement/bgimg3.png",
      MainImgSrc: "/Assets/Images/Service/Services/multimediaAdvertisement/img3.png",
       baseLink: "/multimedia-services"
    },

    {
      id:4,
      title: "Theatres Ads",
      description: "Theatre advertising delivers your message to a captive audience in a premium entertainment setting.",
      bgImgSrc: "/Assets/Images/Service/Services/multimediaAdvertisement/bgimg4.png",
      MainImgSrc: "/Assets/Images/Service/Services/multimediaAdvertisement/img4.png",
       baseLink: "/multimedia-services"
    },

    {
      id:5,
      title: "Airport TV Ads",
      description: "Airport TV advertising is a premium way to reach a captive and affluent audience.",
      bgImgSrc: "/Assets/Images/Service/Services/multimediaAdvertisement/bgimg5.png",
      MainImgSrc: "/Assets/Images/Service/Services/multimediaAdvertisement/img5.png",
       baseLink: "/multimedia-services"
    }

  ]


  return (
    <>
      <section className="Multimedia_Advertising">
        <div className="row">

          {data?.length > 0 && data?.map((item) => {
            return (
              <div className="col-xl-4 col-md-6">
                <Service_outer_card  title={item?.title} description={item?.description} bgImgSrc={item?.bgImgSrc} MainImgSrc={item?.MainImgSrc} baseLink={item?.baseLink} id={item?.id}  />
              </div>
            )
          })}



          {/* <div className="col-xl-4 col-md-6">
            <Service_outer_card />
          </div>

          <div className="col-xl-4 col-md-6">
            <Service_outer_card />
          </div>

          <div className="col-xl-4 col-md-6">
            <Service_outer_card />
          </div>

          <div className="col-xl-4 col-md-6">
            <Service_outer_card />
          </div>

          <div className="col-xl-4 col-md-6">
            <Service_outer_card />
          </div> */}
        </div>
      </section>
    </>
  );
}

export default Multimedia_Advertising;
